import { render, staticRenderFns } from "./PromotionChangeForm.vue?vue&type=template&id=76b25356&"
import script from "./PromotionChangeForm.vue?vue&type=script&lang=js&"
export * from "./PromotionChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports